import Link from 'next/link';
import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
  padding: 24px;
  margin: 10px 0px;
  border-radius: 8px;
`;
export const TextContainer = styled.div`
  font-size: 16px;
  text-align: center;
`;
export const SearchTitle = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primaryBrand};
`;

export const CountTitle = styled.span`
  font-weight: 600;
`;
export const NavigationContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    gap: 10px;
  }
`;
export const NavigationButton = styled.div<{ disabled: boolean }>`
  display: flex;
  justify-content: center;
  gap: 11px;
  text-align: center;
  height: 34px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    height: 30px;
    gap: 6px;
  }
`;
export const NavigationButtonTitle = styled.span<{ disabled: boolean }>`
  font-weight: 400;
  font-size: 16px;
  line-height: 34px;
  color: ${({ disabled, theme }) =>
    disabled ? theme.palette.iron : theme.palette.primaryBrand};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    line-height: 30px;
  }
`;
export const PageNumbersContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    gap: 5px;
  }
`;

export const PageButton = styled(Link)<{ $isActive: boolean }>`
  width: 34px;
  height: 34px;
  background-color: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.primaryBrand : theme.palette.lynxWhite};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.white : theme.palette.primaryBrand};
  border: none;
  border-radius: 8px;
  cursor: ${({ $isActive }) => ($isActive ? 'default' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: ${({ $isActive, theme }) =>
      $isActive ? theme.palette.white : theme.palette.primaryBrand};
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    width: 30px;
    height: 30px;
  }
`;
